export default __webpack_public_path__ + "56d59ad39ad8beacba6e434e88a50ce2.svg";